import { api } from './index';

export default {
  getOrderRefunds(params) {
    return api({
      method: 'GET',
      url: '/refunds',
      params,
    });
  },
  createRefund(id, data) {
    return api({
      method: 'POST',
      url: `refunds/${id}`,
      data,
    });
  },
  getOrderRefund(id) {
    return api({
      method: 'GET',
      url: `/refunds/${id}`,
    });
  },
  acceptAllRefund(id) {
    return api({
      method: 'post',
      url: `/refunds/accept_all/${id}`,
    });
  },
  acceptRefund(id, refundProductId) {
    return api({
      method: 'post',
      url: `/refunds/accept/${id}`,
      data: {
        refund_product: {
          id: refundProductId,
        },
      },
    });
  },
  confirmReceived(id) {
    return api({
      method: 'post',
      url: `refunds/confirm_received/${id}`,
    });
  },
  completeRefund(id) {
    return api({
      method: 'post',
      url: `refunds/complete/${id}`,
    });
  },
  rejectRefund(id, data) {
    return api({
      method: 'post',
      url: `refunds/reject/${id}`,
      data,
    });
  },
  rejectAllRefund(id, data) {
    return api({
      method: 'post',
      url: `/refunds/reject_all/${id}`,
      data,
    });
  },
};
